// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-btns-list .container-wrapper{display:flex;align-items:flex-start;padding-bottom:10px}.radio-btns-list .container-wrapper .MuiButtonBase-root{padding:2px 10px 0 0}.radio-btns-list .container-wrapper:last-child{padding-bottom:0}@media (max-width: 960px){.radio-btns-list label{font-size:16px}}\n", ""]);
// Exports
module.exports = exports;
